import {
  Typography,
  Button,
  Box,
  IconButton,
  Divider,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableContainer,
  Paper,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import TableCell from '@mui/material/TableCell';
import useAppStore from 'store/useAppStore';
import { getScripts } from 'utils/getScript';
import Chart from './Chart';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));
const PrintDialog = ({ currentProjectName, onClose }) => {
  const projectTitle = currentProjectName || '未命名專案';
  const materialDevices = useAppStore((state) => state.materialDevices);
  const materialDeviceKeys = useAppStore((state) => state.materialDeviceKeys);
  const stations = useAppStore((state) => state.stations);
  const stationKeys = useAppStore((state) => state.stationKeys);
  const scripts = useAppStore((state) => state.scripts);
  const fullScript = useAppStore((state) => state.editedFullScript);
  return (
    <>
      <Box
        sx={{
          fontFamily:
            'Microsoft JhengHei, PingFang TC, Noto Sans TC, Arial, sans-serif',
          padding: '20px',
          lineHeight: 1.6,
        }}
      >
        <div className="flex justify-end">
          <IconButton onClick={onClose} className="print:hidden">
            <Close />
          </IconButton>
        </div>
        <Typography className="text-center" variant="h4" color="primary">
          {projectTitle} - PLC 腳本報告
        </Typography>
        <Typography className="mt-4" color="primary" variant="h6">
          1. 物料移動設備列表
        </Typography>
        <Divider
          className="my-3 border-1"
          sx={{ borderColor: 'primary.main' }}
        />
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow className="bg-[#f5f5f5]">
                {materialDeviceKeys.map((key) => (
                  <TableCell key={key}>{key}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {materialDevices.map((device) => (
                <StyledTableRow key={device.id}>
                  {materialDeviceKeys.map((key) => (
                    <TableCell key={key}>{device[key]}</TableCell>
                  ))}
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Typography className="mt-4" color="primary" variant="h6">
          2. 站台列表
        </Typography>
        <Divider
          className="my-3 border-1"
          sx={{ borderColor: 'primary.main' }}
        />
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow className="bg-[#f5f5f5]">
                {stationKeys.map((key) => (
                  <TableCell key={key}>{key}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {stations.map((device) => (
                <StyledTableRow key={device.id}>
                  {stationKeys.map((key) => (
                    <TableCell key={key}>{device[key]}</TableCell>
                  ))}
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Typography className="mt-4" color="primary" variant="h6">
          3. 流程圖
        </Typography>
        <Divider
          className="my-3 border-1"
          sx={{ borderColor: 'primary.main' }}
        />
        <Paper
          variant="outlined"
          sx={{
            maxWidth: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Chart />
        </Paper>
        <Typography className="mt-4" color="primary" variant="h6">
          4. 區段流程列表
        </Typography>
        <Divider
          className="my-3 border-1"
          sx={{ borderColor: 'primary.main' }}
        />
        <div className="flex flex-col gap-4">
          {getScripts(scripts).map((script, index) => {
            return (
              <Paper key={index} variant="outlined" className="p-4">
                <Typography variant="subtitle1">
                  腳本 {index + 1}: {script['區段腳本名稱'] || '未命名腳本'}
                </Typography>
                <div className="mt-2">
                  <span className="font-bold mr-2">起始工站:</span>
                  {script['起始工站'] || ''}
                </div>
                <div className="mt-2">
                  <span className="font-bold mr-2">目標工站:</span>
                  {script['目標工站'] || ''}
                </div>
                <div className="mt-2">
                  <span className="font-bold mr-2">移動設備:</span>
                  {script['移動設備'] || ''}
                </div>
                <div className="mt-2 bg-[#f8f9fa] p-2">
                  <span className="font-bold">腳本內容:</span>
                  <pre className="text-xs">
                    {script.segScript || '尚未生成腳本內容'}
                  </pre>
                </div>
              </Paper>
            );
          })}
        </div>
        <Typography className="mt-4" color="primary" variant="h6">
          5. 全局腳本流程
        </Typography>
        <Divider
          className="my-3 border-1"
          sx={{ borderColor: 'primary.main' }}
        />
        <Paper variant="outlined" className="bg-[#f8f9fa] p-2">
          <pre className="whitespace-pre text-xs">
            {fullScript || '尚無全局腳本流程'}
          </pre>
        </Paper>
        <div className="text-center text-xs mt-6">
          生成時間: {new Date().toLocaleString()}
        </div>
        <div className="flex justify-center mt-10 gap-4">
          <Button
            variant="contained"
            className="print:hidden"
            onClick={() => {
              window.print();
            }}
          >
            列印
          </Button>
          <Button
            variant="contained"
            className="print:hidden"
            onClick={onClose}
          >
            關閉
          </Button>
        </div>
      </Box>
    </>
  );
};
export default PrintDialog;
